import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { ErrorsService } from 'src/app/core/errors/errors-service/errors.service';
import { SiteHeaderService } from 'src/app/site-header/site-header.service';

@Component({
    selector: 'yeshiva-logo',
    templateUrl: './yeshiva-logo.component.html',
    styleUrls: ['./yeshiva-logo.component.scss'],
    standalone: true,
})
export class YeshivaLogoComponent implements OnInit {
    private http = inject(HttpClient);
    private sanitizer = inject(DomSanitizer);
    private _siteHeaderService = inject(SiteHeaderService);
    private errorService = inject(ErrorsService);
    private _cdr = inject(ChangeDetectorRef);

    @Input() customLogo = false;
    customSvg: SafeHtml = '';

    ngOnInit(): void {
        if (this.customLogo) {
            // We need to bypass and create the SVG manually otherwise it wouldn't be possible to change it's color and size.
            this._siteHeaderService.getLogoSvg().subscribe({
                next: (data) => {
                    if (data) {
                        this.customSvg = this.sanitizer.bypassSecurityTrustHtml(data);
                        this._cdr.markForCheck();
                    }
                },
                error: (err) => {
                    this.errorService.log(err);
                },
            });
        }
    }
}
